var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#145da0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1536 14.6154C15.4281 14.6154 16.4613 13.5822 16.4613 12.3077C16.4613 11.0332 15.4281 10 14.1536 10C12.8791 10 11.8459 11.0332 11.8459 12.3077C11.8459 13.5822 12.8791 14.6154 14.1536 14.6154Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.0766H18.3077V20.5762C18.3003 19.8726 18.1148 19.1824 17.7684 18.57C17.4219 17.9575 16.9259 17.4429 16.3267 17.0742C15.7275 16.7054 15.0445 16.4945 14.3417 16.4612C14.2791 16.4583 14.2164 16.4567 14.1538 16.4566C14.0913 16.4567 14.0286 16.4583 13.966 16.4612C13.2632 16.4945 12.5802 16.7054 11.981 17.0742C11.3818 17.4429 10.8858 17.9575 10.5393 18.57C10.1929 19.1824 10.0073 19.8726 10 20.5762V21.0766Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8461 14.6154C19.1206 14.6154 20.1538 13.5822 20.1538 12.3077C20.1538 11.0332 19.1206 10 17.8461 10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1538 21.0769H22V20.5764C21.9926 19.8728 21.8071 19.1826 21.4606 18.5702C21.1142 17.9577 20.6182 17.4431 20.019 17.0744C19.6317 16.836 19.2093 16.6636 18.7692 16.5625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/total-users.516554b39dd11c0a13c2e47325ed9f1b.svg";
export { ForwardRef as ReactComponent };